import React from "react";
import { APP_PREFIX_PATH } from "configs/AppConfig";

export const tmsRoutes = [
    {
        key: "tms-list",
        exact: true,
        path: `${APP_PREFIX_PATH}/tms/tms-list`,
        component: React.lazy(() => import("views/app-views/tms/pages/TenderList")),
    },
    {
        key: "tms-create",
        exact: true,
        path: `${APP_PREFIX_PATH}/tms/tms-create`,
        component: React.lazy(() => import("views/app-views/tms/pages/CreateTender")),
    },
    {
        key: "tms-summary",
        exact: true,
        path: `${APP_PREFIX_PATH}/tms/tms-summary/:id`,
        component: React.lazy(() => import("views/app-views/tms/pages/TenderSummary")),
    },
    {
        key: "tms-assets",
        exact: true,
        path: `${APP_PREFIX_PATH}/tms/tms-assets`,
        component: React.lazy(() => import("views/app-views/tms/pages/AssetsList")),
    },
];